import axios from "./axios";

const BASE = "/company/settings/integrations/oauth_apps";

export function fetchCompanyOauthApps() {
  return axios.get(BASE).then((res) => res.data);
}

export function createCompanyOauthApp(payload) {
  return axios.post(BASE, payload).then((res) => res.data);
}

export function updateCompanyOauthApp(id, payload) {
  return axios.patch(`${BASE}/${id}`, payload).then((res) => res.data);
}

export function deleteCompanyOauthApp(id, confirmName) {
  return axios
    .delete(`${BASE}/${id}`, { data: { confirm_name: confirmName } })
    .then((res) => res.data);
}

export function rollCompanyOauthAppKeys(id, { rollUid = true, rollSecret = true } = {}) {
  return axios
    .post(`${BASE}/${id}/roll_keys`, { roll_uid: rollUid, roll_secret: rollSecret })
    .then((res) => res.data);
}
